import { DateObject, useSettings } from '@capsicum/common';
import { useMe } from '@capsicum/socios-core';
import { useMemo } from 'react';

type UsePoblanoTutorialEligibilityProps = {
	enabled: boolean;
};

export const usePoblanoTutorialEligibility = ({ enabled }: UsePoblanoTutorialEligibilityProps = { enabled: true }) => {
	const {
		areSettingsLoading,
		settings: { isPoblanoEnabled, poblanoReleaseDate: poblanoReleaseDateSetting }
	} = useSettings();

	const isEnabled = enabled && isPoblanoEnabled;

	const { isMeLoading, me } = useMe({ enabled: isEnabled });

	const isLoading = isMeLoading || areSettingsLoading;
	const poblanoReleaseDate = useMemo(() => new DateObject(poblanoReleaseDateSetting), [poblanoReleaseDateSetting]);
	const userRegistrationDate = useMemo(() => (!me.createdAt ? null : new DateObject(me.createdAt)), [me.createdAt]);

	const isExistingUser = useMemo(
		() => poblanoReleaseDate.isAfter(userRegistrationDate),
		[poblanoReleaseDate, userRegistrationDate]
	);

	return {
		isEnabled,
		isExistingUser,
		isLoading
	};
};
